var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('router-view'),(_vm.windowWidth > 425)?_c('preview-modal'):_vm._e(),_c('register-modal'),(_vm.restoreModal.open)?_c('confirm-restore-profile'):_vm._e(),_c('verification-modal'),_c('app-alerts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }